import React from 'react';
import { shape } from 'prop-types';

import VideoPlayer from 'components/Gallery/GalleryItem/Video/VideoPlayer';

import styles from './Video.module.scss';

const Video = ({ content }) => (
  <div className={styles.wrapper}>
    <div className={styles.mediaContainer}>
      <VideoPlayer
        youtubeId={content.youtubeVideoId}
        thumbnail={
          content.videoCoverImageUrl
            ? content.videoCoverImageUrl
            : `https://img.youtube.com/vi/${content.youtubeVideoId}/maxresdefault.jpg`
        }
      />
    </div>
    <p className={styles.videoDescription}>{content.imageDescription}</p>
  </div>
);

Video.propTypes = {
  content: shape(),
};

Video.defaultProps = {
  content: null,
};

export default Video;
